import React, { useContext, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import { Box } from "../Box";
import { VectorLogo } from "../VectorLogo";
import { Flex } from "../Flex";
import { DesktopMenuContainer } from "../../containers/DesktopMenuContainer/DesktopMenuContainer";
import { NavBarContainer } from "../../containers/NavBarContainer";
import { Link } from "../Link";
import { Image } from "../Image";
import { Button } from "../Button";
import { SecondaryMobileHeader } from "../SecondaryHeader/_/SecondaryMobileHeader/SecondaryMobileHeader";

import Phone from "../../assets/images/phone.svg";
import MyProfile from "../../assets/images/myprofile.svg";
import { MobileMenuContainer } from "../../containers/MobileMenuContainer";

const StyledVectorLogo = styled(VectorLogo)``;

const StyledFlexBox = styled(Flex)`
  @media (max-width: 992px) {
    display: none;
  }
`;

const MobileDisplay = styled(Flex)`
  @media (min-width: 992px) {
    display: none;
  }
`;

export const ServiceCatalogueHeader: React.FC = () => {
  const [displayProfile, setDisplayProfile] = useState(false);
  const theme = useContext(ThemeContext);
  const handleClick = () => setDisplayProfile(prevState => !prevState);

  return (
    <Flex flexDirection="column" bg="primary" data-testid="header">
      <Box width={["100%", "100%", "750px", "970px", "1170px"]} m="auto" px={["0px", "0px", "0px", "0px", "15px"]}>
        <NavBarContainer />

        <Flex
          mt={["16px", "16px", "16px", "16px", "27px"]}
          pl={["10px", "10px", "10px", "10px", "31px"]}
          pr="10px"
          justifyContent="space-between"
        >
          <Flex mt="5px">
            <SecondaryMobileHeader serviceCatalogueNav />
            <Link href="https://www.vector.co.nz">
              <StyledVectorLogo data-testid="VectorLogo" />
            </Link>
          </Flex>

          {displayProfile ? (
            <MobileMenuContainer show={displayProfile} onClose={handleClick} serviceCatalogueNav myProfile={displayProfile} />
          ) : (
            <Box px={2} mb="25px" mt="4px" data-testid="OutageCentre">
              <Link href="https://help.vector.co.nz/address" data-gatrack-label="header - check outages">
                <Button
                  px={[2, 2, 2, 3]}
                  py={2}
                  variant="outlined"
                  border="2px solid"
                  fontSize={["13px", "13px", "13px", "16px"]}
                  lineHeight={["21px", "21px", "21px", "24px"]}
                  fontWeight={700}
                >
                  check outages
                </Button>
              </Link>

              <MobileDisplay mr={[0, 0, 0, 4]} mt="24px" mb="11px" justifyContent="space-around">
                <Link ml="22px" color={theme.colors.background} href="tel:0508 832 867" aria-label="Open Data" data-testid="PhoneIcon">
                  <Image src={Phone} alt="phone-icon" />
                </Link>

                <Box onClick={handleClick}>
                  <Image data-testid="PersonIcon" src={MyProfile} alt="profile-icon" />
                </Box>
              </MobileDisplay>
            </Box>
          )}
        </Flex>

        <StyledFlexBox justifyContent="center">
          <Box width="100%" mt="11px" mx={2}>
            <DesktopMenuContainer />
          </Box>
        </StyledFlexBox>
      </Box>
    </Flex>
  );
};

ServiceCatalogueHeader.defaultProps = {
  dataType: "servicecatalogueheader",
};
